import classNames from "classnames";
import { motion } from "framer-motion";
import { GamesByTechnique } from "shared/games/allTechniqueGameDescriptions";
import { GameRound } from "shared/games/types/GameRound";
import Button from "ui/atoms/Button/Button";
import * as a from "../../animationConsts";
import useOnChangeHandler from "../../../../molecules/GameRoundBuilders/useOnChangeHandler";
import TechniqueShape from "../../../../molecules/GameRoundBuilders/TechniqueShape";

interface Props {
  techniques: GamesByTechnique[];
  technique: GamesByTechnique;
  index: number;
  changers: ReturnType<typeof useOnChangeHandler>;
  value: GameRound;
}

export default function AdvancedTechniqueAndGameSelector({
  techniques,
  technique,
  index,
  changers,
  value,
}: Props) {
  return (
    <motion.div
      key={technique.technique}
      layoutId={technique.technique}
      layout="position"
      transition={{ duration: 0.3, delay: (index - 1) * 0.05 }}
      initial={{
        opacity: index === 0 ? 1 : a.initial.opacity,
        y: index === 0 ? "auto" : a.initial.y,
      }}
      exit={a.exit}
      animate={a.animate}
    >
      <div className={classNames("grid grid-cols-[125px_1fr] gap-6")}>
        <div className="flex items-center justify-center">
          <div className="w-full">
            <TechniqueShape
              changers={changers}
              technique={technique}
              value={value}
            />
          </div>
        </div>

        <div>
          <div className="-mb-2 flex flex-wrap py-3">
            {Object.values(technique.games).map((game) => (
              <motion.span
                key={game.game}
                className="mb-2 mr-2"
                initial={{ opacity: 0, y: -10 }}
                exit={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.2,
                  delay: 0.1 + index * 0.05,
                }}
              >
                <Button
                  theme="default"
                  overflow="wrap"
                  active={value.games.includes(game.game)}
                  onClick={() => changers.onGameToggle(game.game)}
                >
                  {game.title}
                </Button>
              </motion.span>
            ))}
          </div>
        </div>
      </div>

      {index < techniques.length - 1 && (
        <hr className="border-1 my-5 border-dashed border-white" />
      )}
    </motion.div>
  );
}
